import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.8,
    backgroundColor: 'black',
    marginVertical: 0
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer1: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '0.5px solid black'
  },
  fontBold: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    textDecoration: 'underline'
  },
  column: {
    flex: 1,
    padding: 3
  },
  wideColumn: {
    flex: 2,
    padding: 3
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndoorRegistrationReportPdfPrint1 = ({ data }) => {
  console.log(data);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`IPD Registeration`}>
          <Page size="A4" style={{ ...styles.page }}>
            {/* First Row */}
            <View style={{ ...styles.contentContainer1, marginTop: '20%' }}>
              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="DEPARTMENT OF :  " />
                </View>
                <View style={styles.row}>
                  <Text content="UHID                      : " />
                  <Text content={`${data.uhid}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Patient Name         : " style={styles.textBold} />
                  <Text content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender           : " style={styles.textBold} />
                  <Text content={`${data.patient.age}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Relative Name       : " style={styles.textBold} />
                  <Text content={`${data.patient.guardian_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Address                 : " style={styles.textBold} />
                  <Text content={`${data.patient.address.address}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor Name         : " style={styles.textBold} />
                  <Text content={`${data.consultant_detail.doctor.name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Department           : " style={styles.textBold} />
                  <Text content={`${data.consultant_detail.department.department}`} />
                </View>
              </View>

              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="Sponsor              : " style={styles.textBold} />
                  <Text content={`${data.patient.sponsor.name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="IPD NO               : " />
                  <Text content={`${data.ipd_no}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Adm. Date/Time  : " style={styles.textBold} />
                  <Text content={`${formatDate(data?.date)} ${data?.time}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Patient Type        : " style={styles.textBold} />
                  <Text content={`${data.adm_type}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Phone No.           : " style={styles.textBold} />
                  <Text content={`${data.patient.address.mobile}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Guardian             : " style={styles.textBold} />
                  <Text content={`${data.patient.guardian_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Relation              : " style={styles.textBold} />
                  <Text content={`${data.patient.guardian_type[0]?.name || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward/Room/Bed : " style={styles.textBold} />
                  <Text
                    content={`${data.consultant_detail.room.ward.name} / ${data.consultant_detail.room.room_no} / ${data.consultant_detail.bed_no}`}
                  />{' '}
                  /
                </View>
              </View>
            </View>

            {/* Second Row */}
            <View style={styles.contentContainer1}>
              <View style={styles.column}>
                <View style={{ ...styles.row, marginLeft: '18%' }}>
                  <Text
                    style={styles.fontBold}
                    content="If Hospital Employee or his/her dependent is admitted, please complete the information below"
                  />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="NAME AND DESIGNATION OF EMPLOYEE " />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="RELATIONSHIP OF PATIENT WITH EMPLOYEE" />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="WARD ENTITLEMENT" />
                </View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>

            {/* Fourth Row */}
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, marginLeft: '40%' }} content="TRANSFER RECORD" />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DATE" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DEPARTMENT" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="UNIT" />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="WARD" />
                </View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>

            {/* Fifth Row */}
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, marginLeft: '40%' }} content="DISCHARGE RECORD" />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="DETAILS OF DISCHARGE :" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="Date :" />
                </View>
              </View>
              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="Time :" />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Todal Days :" />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Final Diagnosis :" style={styles.textBold} />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Internal Code OF Disease :" style={styles.textBold} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Account Clearance :" />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="1. Copy of Dicharge Card Atteched (Tick Option)" style={styles.textBold} />
                </View>
                <View style={styles.row}>
                  <Text content="2. Not Attached Summary :-" style={styles.textBold} />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={{ ...styles.contentContainer, padding: 20 }}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Result :" style={styles.textBold} />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DISCHARGED" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="LAMA" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DOPR" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="REFERAL" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="EXPIRED" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="ABSCONDED" />
                </View>
              </View>
            </View>

            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DISCHARGED" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="LAMA" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DOPR" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="REFERAL" />
                </View>
              </View>
            </View>

            {/* --------------------------------Old Format ----------------------------- */}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
